import { QueryClient } from '@tanstack/react-query'

/**
 * Le client React Query du site public.
 *
 * Il vit au niveau du module, et non dans le corps d'un composant : construit
 * dans `App()`, il était recréé à chaque rendu — et `App` se rend à chaque
 * navigation, puisqu'il observe le routeur pour décider d'afficher le chat.
 * Chaque changement de page jetait donc tout le cache, y compris le
 * `staleTime` de 20 minutes des recherches de vols, qui ne servait à rien.
 *
 * Un seul client suffit : l'application est une SPA, il n'y a pas de rendu
 * serveur qui exigerait un client par requête.
 */
export const appQueryClient = createAppQueryClient()

/**
 * Les réglages partagés par le site et le widget de recherche embarqué.
 *
 * `retry: false` est le choix structurant : nos erreurs sont rédigées et
 * classées (voir `lib/client-error.ts`), les rejouer en silence retarderait
 * l'écran qui explique quoi faire — et sur un appel Affidium de vingt
 * secondes, trois tentatives feraient patienter une minute pour rien.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 5 * 60 * 1000,
      },
    },
  })
}
